export interface ProjectRole {
  id: number;
  name?: string;
  state?: string;
  color?: string;
  [key: string]: any;
}
